import React from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiArrowRight, FiSun } = FiIcons;

export default function Hero() {
  return (
    <section className="relative pt-32 pb-16 lg:pt-48 lg:pb-24 overflow-hidden">
      <div className="absolute inset-0 -z-10 bg-[radial-gradient(circle_at_top_right,_#e6f4ea,_#ffffff)]"></div>
      
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          <motion.div
            initial={{ opacity: 0, x: -30 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.6 }}
          >
            <div className="inline-flex items-center gap-2 py-1.5 px-4 rounded-full bg-[#005b2d]/10 text-[#005b2d] text-sm font-bold mb-6">
              <SafeIcon icon={FiSun} className="text-[#005b2d]" />
              <span>BE A BEACON OF LIGHT</span>
            </div>
            
            <h1 className="text-5xl lg:text-7xl font-extrabold text-[#2A1A0F] leading-tight mb-8">
              Heal Your Body, <br />
              <span className="text-[#005b2d]">Light the Way.</span>
            </h1>
            
            <p className="text-xl text-slate-600 mb-10 leading-relaxed max-w-xl">
              We are Pete & Rosemary. Through our nonprofit foundation <strong>Where the Love Grows</strong> and our partnership with NeoLife, we empower you to heal holistically and become a beacon of hope for others.
            </p>
            
            <div className="flex flex-col sm:flex-row flex-wrap gap-4">
              <a 
                href="https://beta.neolife.com/peteandrosemary/en-US"
                target="_blank"
                rel="noopener noreferrer"
                className="btn-neolife-primary"
              >
                Start Your Journey
                <SafeIcon icon={FiArrowRight} />
              </a>
              <a 
                href="https://beta.neolife.com/peteandrosemary/en-US/enrollment"
                target="_blank"
                rel="noopener noreferrer"
                className="btn-neolife-outline"
              >
                Join Our Mission
              </a>
            </div>
          </motion.div>

          <motion.div 
            className="relative"
            initial={{ opacity: 0, scale: 0.9 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.6, delay: 0.2 }}
          >
            <div className="relative z-10 rounded-[2.5rem] overflow-hidden shadow-2xl border-[12px] border-white bg-white">
              <img 
                src="/media/hero.jpeg"
                alt="Pete and Rosemary" 
                className="w-full aspect-[4/5] object-cover object-top"
              />
            </div>
            <div className="absolute -top-10 -right-10 w-64 h-64 bg-[#005b2d]/10 rounded-full blur-3xl -z-10"></div>
            <div className="absolute -bottom-10 -left-10 w-64 h-64 bg-yellow-400/10 rounded-full blur-3xl -z-10"></div>
          </motion.div>
        </div>
      </div>
    </section>
  );
}